// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3OIo7","head":"Table_head__3cOQw","col":"Table_col__9DTZ8"};